import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Toast from './Toast';
import { useToast } from '../../hooks';

const Layout = ({ children, className = '' }) => {
  const { toasts, removeToast } = useToast();



  return (
    <div className="min-h-screen flex flex-col bg-soft-white relative overflow-hidden">
      {/* Global Background Elements */}
      <div className="fixed top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div
          className="absolute inset-0 opacity-70"
          style={{
            backgroundImage: 'radial-gradient(1200px circle at 15% -20%, rgba(244, 208, 63, 0.18), transparent 55%), radial-gradient(900px circle at 90% -10%, rgba(139, 195, 74, 0.14), transparent 45%), linear-gradient(180deg, rgba(255, 248, 220, 0.5), rgba(254, 254, 254, 0))'
          }}
        />
        <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-bl from-pragyavan-gold/5 to-transparent rounded-full blur-3xl transform translate-x-1/4 -translate-y-1/4" />
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-sage-green/5 to-transparent rounded-full blur-3xl transform -translate-x-1/4 translate-y-1/4" />
        <div className="absolute top-1/2 left-1/2 w-full h-full bg-gradient-to-br from-pragyavan-cream/10 to-transparent rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2 opacity-50" />
      </div>

      <div className="relative z-10 flex flex-col min-h-screen">
        <Header />

        <main className={`flex-1 ${className}`}>
          {children}
        </main>

        <Footer />
      </div>

      {/* Toast Container */}
      <div className="fixed top-4 right-4 z-50 space-y-2">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            {...toast}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default Layout;
